// @ts-nocheck

import { createContext } from 'react';

export type MatchBetFilter = {
  id: string;
  label: string;
  nbBets?: number;
  position: number;
  filters?: Array<MatchBetFilter>;
  parentId?: number;
  sliderValues?: Array<{ value: string; label: string }>;
};

type MatchBetFiltersHandlerContextProps = {
  currentFilter: MatchBetFilter | null;
};
export const MatchBetFiltersHandlerContext = createContext<MatchBetFiltersHandlerContextProps>({ currentFilter: null });

type MatchViewContextProps = {
  matchId: number;
  promoSize?: number;
  setPromoSize?: (promoSize: number) => void;

  toolbarSize?: number;
  setToolbarSize?: (toolbarSize: number) => void;

  widgetSize?: number;
  setWidgetSize?: (widgetSize: number) => void;
  isWidgetSticky?: boolean;
  setIsWidgetSticky?: (isWidgetSticky: boolean) => void;

  initialHeaderSize?: number;
  setInitialHeaderSize?: (initialHeaderSize: number) => void;
  headerSize?: number;
  setHeaderSize?: (headerSize: number) => void;
  isHeaderSticky?: boolean;
  setIsHeaderSticky?: (isHeaderSticky: boolean) => void;
};
export const MatchViewContext = createContext<MatchViewContextProps>({});

type MatchBetFiltersContextProps = {
  filterId: string | null;
  setIsHotFilterSelected?: (next: boolean) => void;
  isHotFilterSelected?: boolean;
  onHotFilterClicked?: () => void;
  setPartialOnHotFilterClicked?: (next: () => void) => void;
};
export const MatchBetFiltersContext = createContext<MatchBetFiltersContextProps>({ filterId: null });
